<template lang="pug">
  .card.mb-0
    .card-body
      .row
        .col-12.mb-1
          h2.section-title.mt-0 
            span(v-if="!isOperator") {{ id }} - 
            span {{ gameName }} ({{ $moment(date).format('YYYY-MM-DD') }})
        .col-10.mb-1
          b-pagination.float-left(
            size="sm"
            hide-ellipsis
            :total-rows="totalRowOperator"
            :per-page="getPageSize"
            v-model="currentPageOperator"
            @input="changedPageOperator($event)")
        .col-2.mb-1
          b-input-group(:prepend="$t('ui.page_size')" size="sm")
            b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeOperator" size="sm")
        .col-6(style="max-height: 70vh; overflow: hidden;")
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
              thead.thead-light
                tr
                  th.text-center(width="3%")
                    span #
                  th(width="10%")
                    span(:title="$t('ui.member_id')") {{ $t('ui.member_id') }}
                  th.text-center(width="10%")
                    span(:title="$t('ui.total_game')") {{ $t('ui.total_game') }}
              tbody.clusterize-content
                tr(v-if="list.length == 0")
                  td(colspan="4").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in list")
                  td.text-center
                    span(:title="((currentPageOperator - 1) * getPageSize + index + 1)") {{ ((currentPageOperator - 1) * getPageSize + index + 1) }}
                  td
                    span(:title="item.member_id") {{ item.member_id }}
                  td.text-center
                    span(:title="item.total_game") {{ item.total_game }}

  </template>

<script>
  import config from "@/config";
  import errorTags from "@/errorTags";
  import SubmitButton from "@/library/SubmitButton.vue";
  import DebounceInput from "@/library/DebounceInput";

  export default {
    components: {
      SubmitButton,
      DebounceInput
    },
    props: {
      id: {
        type: String,
        default: ''
      },
      date: {
        type: String,
        default: ""
      },
      gameId: {
        type: Number,
        default: ""
      },
      gameName: {
        type: String,
        default: ""
      }
    },
    data: () => ({
      loading: false,
      list: [],
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      currentPageOperator: 1,
      totalRowOperator: 0,
    }),
    computed: {
      getPageSize() {
        return this.$store.getters.pageSize;
      },
      isOperator() {
        return [2].includes(this.$store.getters.accountType);
      }
    },
    mounted: function() {  },
    methods: {
      getList: function(isSearch) {
        let url = config.getOperatorMiniGameRequestDetailsUrl();

        if (isSearch) this.currentPageOperator = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.id != null ? this.id : '',
          working_date: this.$moment(this.date).format('YYYY-MM-DD'),
          game_id: this.gameId,
          page_number: this.currentPageOperator,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.list = response.data.dt;
                  this.totalRowOperator = this.list.length > 0 ? this.list[0].totalrows : 0;
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      },
      changedPageSizeOperator: function(pageSize) {
        this.$store.dispatch("layout/setPageSize", pageSize);
        this.currentPage = 1;
        this.getList(true);
      },
      changedPageOperator: function(pageNo) {
        this.currentPage = pageNo;
        this.getList();
      },
      handleFailed: function(tag, status) {
        this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
      }
    }
  };
  </script>